export default {
  clientName: { id: 'client_name' },
  siteSIEP: { id: 'site_siep' },
  region: { id: 'region' },
  specie: { id: 'specie' },
  stockingMonthYear: { id: 'stocking_month_year' },
  stockingFishCount: { id: 'stocking_fish_count' },
  stockingWeight: { id: 'stocking_weight' },
  monthsFromStocking: { id: 'number_of_farming_month' },
  numberOfCages: { id: 'number_of_cages' },
  harvestingMonthYear: { id: 'harvesting_month_year' },
  harvestingLength: { id: 'harvesting_length' },
  save: { id: 'save' },
  cancel: { id: 'cancel' },
  siteAddedSuccessfully: { id: 'site_added_successfully' },
  siteUpdatedSuccessfully: { id: 'site_updated_successfully' },
  newRow: { id: 'new_row' },
  deactivatedRows: { id: 'deactivated_rows' },
  yearClass: { id: 'year_class' },
  productFamilyName: { id: 'product_family_name' },
  seawater: { id: 'seawater' },
  freshwater: { id: 'freshwater' },
  monthYear: { id: 'month_year' },
  skuEcto: { id: 'sku_ecto' },
  userProjectedProductFamily: { id: 'user_projected_product_family' },
  userProjectedBaseProduct: { id: 'user_projected_base_product' },
  userProjectedDietGroup: { id: 'user_projected_diet_group' },
  userProjectedHistidine: { id: 'hist_at' },
  userProjectedPigment: { id: 'user_projected_pigment' },
  userProjectedPigment2: { id: 'user_projected_pigment' },
  userProjectedAdditives: { id: 'user_projected_additives' },
  userProjectedProduct: { id: 'user_projected_product' },
  predictedFeedConsumption: { id: 'predicted_feed_consumption' },
  userProjectedFeedConsumption: { id: 'user_projected_feed_consumption' },
  predictedSales: { id: 'predicted_sales' },
  userProjectedSales: { id: 'user_projected_sales' },
  reason: { id: 'reason' },
  chart: { id: 'chart' },
  actions: { id: 'actions' },
  showFilters: { id: 'show_filters' },
  tablesManagement: { id: 'tables_management' },
  modified: { id: 'modified' },
  created: { id: 'created' },
  permission: { id: 'permission' },
  mainTable: { id: 'main_table' },
  chooseUsers: { id: 'choose_users' },
  name: { id: 'name' },
  duplicate: { id: 'duplicate' },
  delete: { id: 'delete' },
  deleteSnapshotConfirmationMessage: {
    id: 'delete_snapshot_confirmation_message',
  },
  deleteSnapshot: { id: 'delete_snapshot' },
  invalidEmptyValue: { id: 'invalid_empty_value' },
  invalidTitle: { id: 'invalid_title' },
  predictionBaseProduct: { id: 'prediction_base_product' },
  snapshot: { id: 'snapshot' },
}
